import { selectByMode } from "./mode";

// Yousign runs against its sandbox in every environment except production.
const config = {
  localhost: { isSandbox: true },
  dev: { isSandbox: true },
  production: { isSandbox: false },
  test: { isSandbox: true },
  demo: { isSandbox: true },
};

export default selectByMode(config);
